import { Spanish as AUTH } from "../../../Web/Views/Public/_Auth/_Resources/_Translate/Spanish";

export const SPANISH = {

    AUTH,

    COMPANY: {
        CLAIM: "Gestión privada de proyectos, documentos, finanzas y credenciales",
        RIGHTS: "Todos los derechos reservados.",
    },

    TEMPLATES: {

        banner: {
            devMode: "⚠️ MODO DESARROLLO: Algunas funciones pueden no estar disponibles.",
            devModeHide: "Ocultar el aviso hasta el próximo refresh",
            devModeHideAria: "Ocultar el aviso de modo desarrollo",
        },

        alerts: {
            confirmTitle: "¿Confirmar acción?",
            confirmOk: "Confirmar",
            cancel: "Cancelar",
            archiveTitle: "¿Archivar este registro?",
            archiveOk: "Sí, archivar",
            deleteTitle: "¿Eliminar definitivamente?",
            deleteOk: "Eliminar definitivamente",
            deleteInputLabel: "Para confirmar, escribí exactamente: ",
            deleteInputPlaceholder: "Escribí acá para habilitar el botón",
            bulkDeleteTitle: "Confirmá la eliminación masiva",
            bulkDeletePlaceholder: "Escribí ELIMINAR",
            bulkDeleteHint: "Para confirmar, escribí:",
            bulkDeleteWord: "ELIMINAR",
            errCode: "El código debe ser de 6 dígitos.",
            errWord: "Debés escribir ELIMINAR exactamente.",
            importTitle: "No se pudo importar",
            importMore: "…y {{count}} fila(s) más con errores.",
            successTitle: "¡Listo!",
            errorTitle: "Ocurrió un error",
            warningTitle: "Atención",
            infoTitle: "Información",
            loadingTitle: "Procesando...",
            ok: "OK",
            close: "Cerrar",
            understood: "Entendido",
        },

        nav: {
            main: "Principal",
            openAside: "Abrir menú lateral",
            openMenu: "Abrir menú",
            closeMenu: "Cerrar menú",
            defaultGroup: "Navegación",
            menu: "Navegación",
            sidebarGroup: "Panel",
        },

        header: {
            favs: "Favoritos",
            favsEmpty: "Todavía no guardaste nada",
            favsHint: "Tocá el corazón para guardar lo que te interese.",
            carts: "Carrito",
            cartsEmpty: "Tu carrito está vacío",
            cartsHint: "Los productos que agregues aparecen acá.",
            checkout: "Finalizar compra",
            notifications: "Notificaciones",
            notificationsEmpty: "No tenés notificaciones",
            notificationsHint: "Acá van a aparecer los avisos del sistema.",
            messages: "Mensajes",
            messagesEmpty: "No tenés mensajes",
            messagesHint: "Las conversaciones del equipo aparecen acá.",
            email: "Correo",
            emailEmpty: "No tenés correos",
            emailHint: "Los correos sin leer aparecen acá.",
            whatsapp: "WhatsApp",
            whatsappEmpty: "No tenés conversaciones",
            whatsappHint: "Los mensajes de clientes aparecen acá.",
            account: "Mi cuenta",
            accountFallback: "Cuenta",
            guest: "Invitado",
            logout: "Cerrar sesión",
            myPanel: "Mi panel",
            myProfile: "Mi perfil",
            archived: "Archivados",
            appearance: "Apariencia",
            language: "Idioma",
            themeLight: "Claro",
            themeDark: "Oscuro",
            themeSystem: "Sistema",
            portal: "Portal de clientes",
            viewAll: "Ver todos ({{total}}) · {{hidden}} más",
        },

        time: {
            now: "hace instantes",
            minutes: "hace {{value}} min",
            hours: "hace {{value}} h",
            days: "hace {{value}} d",
        },
        common: {
            save: "Guardar",
            saveChanges: "Guardar cambios",
            cancel: "Cancelar",
            discard: "Descartar",
            close: "Cerrar",
            back: "Atrás",
            next: "Siguiente",
            finish: "Finalizar",
            edit: "Editar",
            delete: "Eliminar",
            remove: "Quitar",
            add: "Agregar",
            create: "Crear",
            search: "Buscar…",
            filter: "Filtrar",
            clearAll: "Limpiar todo",
            all: "Todas",
            retry: "Reintentar",
            reload: "Recargar la página",
            loading: "Cargando…",
            confirm: "Confirmar",
            accept: "Aceptar",
            viewAll: "Ver todos",
            seeMore: "Ver más",
            seeLess: "Ver menos",
            copy: "Copiar",
            copied: "Copiado",
            print: "Imprimir",
            export: "Exportar",
            import: "Importar",
            today: "Hoy",
            yesterday: "Ayer",
            empty: "Sin datos",
            required: "Este campo es obligatorio",
            optional: "opcional",
        },

        screen: {
            notFoundTitle: "No encontramos esta página",
            notFoundText: "El enlace puede haber cambiado de dirección o la página ya no existe.",
            goHome: "Ir al inicio",
            reload: "Recargar la página",
            requiredPermission: "Permiso requerido",
            forbiddenTitle: "No tenés permiso para ver esto",
            forbiddenText: "Tu cuenta no tiene acceso a esta sección. Si creés que es un error, pedile acceso a un administrador.",
            errorTitle: "Algo salió mal",
            errorText: "No pudimos completar la operación. Probá de nuevo en unos segundos.",
            maintenanceTitle: "Estamos haciendo mejoras",
            maintenanceText: "El sistema vuelve a estar disponible en unos minutos. Gracias por la paciencia.",
            maintenanceEta: "Estimamos volver",
            emptyTitle: "Todavía no hay datos",
            emptyText: "Cuando se cargue el primer registro va a aparecer acá.",
            noticeTitle: "No pudimos traer la información",
            noticeText: "El servidor respondió sin datos. Probá recargar o revisá los filtros aplicados.",
            offlineTitle: "Sin conexión con el servidor",
            offlineText: "No obtuvimos respuesta. Revisá tu conexión e intentá de nuevo.",
        },

        form: {
            unsavedChanges: "Tenés cambios sin guardar",
            savedAt: "Guardado",
            saveError: "No pudimos guardar los cambios.",
            stepOf: "Paso {{current}} de {{total}}",
            checkStep: "Revisá los campos de este paso.",
            validateError: "No pudimos validar este paso.",
            noValue: "Sin valor",
            cannotBeEmpty: "Este campo no puede quedar vacío.",
            invalidValue: "Valor inválido.",
            saveShortcut: "Ctrl + S",
        },

        table: {
            noResults: "Sin resultados",
            rowsCount: "{{count}} filas",
            perPage: "Por página",
            page: "Página",
            of: "de",
            selected: "{{count}} seleccionados",
        },

        uploader: {
            dropTitle: "Arrastrá archivos o hacé clic",
            emptyList: "Todavía no subiste nada",
            uploadedCount: "{{done}} de {{total}} subidos",
            clear: "Vaciar",
            tooLarge: "Supera el máximo de {{max}}.",
            wrongType: "Tipo de archivo no permitido.",
            maxFiles: "Máximo {{max}} archivos.",
        },

        social: {
            commentPlaceholder: "Escribí un comentario…",
            commentSubmit: "Comentar",
            reply: "Responder",
            noComments: "Todavía no hay comentarios",
            sendHint: "Ctrl + Enter para enviar",
            chatPlaceholder: "Escribí un mensaje…",
            noMessages: "Todavía no hay mensajes",
            newMessages: "Mensajes nuevos",
            attach: "Adjuntar archivo",
            send: "Enviar",
        },

        notifications: {
            title: "Notificaciones",
            empty: "No tenés notificaciones",
            emptyUnread: "Estás al día",
            unread: "Sin leer",
            markAll: "Marcar todas como leídas",
            dismiss: "Descartar aviso",
            impersonation: "Estás viendo el sistema como {{name}}. Todo lo que hagas queda registrado a su nombre.",
            exitImpersonation: "Volver a mi cuenta",
        },

        command: {
            placeholder: "Buscá una acción o una página…",
            empty: "Sin resultados",
            footer: "↑↓ para moverte · Enter para ejecutar · Esc para cerrar",
            shortcutsTitle: "Atajos de teclado",
            shortcutsSearch: "Buscar un atajo…",
            shortcutsEmpty: "No hay atajos que coincidan",
        },

        calendar: {
            weekdays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
            months: [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
            ],
            month: "Mes",
            agenda: "Agenda",
            today: "Hoy",
            noEvents: "No hay eventos en este mes",
            more: "+{{count}} más",
        },

        charts: {
            empty: "Sin datos para graficar",
            others: "Otros",
            vsPrevious: "vs. período anterior",
            noChanges: "No hay diferencias",
            before: "Antes",
            after: "Después",
            less: "Menos",
            more: "Más",
            totalCount: "{{count}} en total",
        },

        pricing: {
            monthly: "Mensual",
            yearly: "Anual",
            perMonth: "/mes",
            perYear: "/año",
            savings: "Ahorrás {{percent}}%",
            choose: "Elegir plan",
            custom: "A medida",
            comparison: "Comparación completa",
            feature: "Característica",
        },


        config: {
            aesthetic: "Estética",
            layout: "Layout",
            table: "Tabla",
            typography: "Tipografía",
            headerPublic: "Header público",
            headerPrivate: "Header privado",
            theme: "Tema",
            alert: "Alertas",
            alertPosition: "Posición de alertas",
            confirm: "Confirmaciones",
            editor: "Editor",

            appearance: "Apariencia",
            implementation: "Implementación",
            locked: "Lo define el proyecto",
            costly: "Cambiar esta opción descarga una librería",
            irreversible: "El contenido guardado no se convierte",
        },

        tour: {
            next: "Siguiente",
            back: "Atrás",
            finish: "Listo",
            skip: "Saltar",
            stepOf: "Paso {{current}} de {{total}}",
        },
    },

};
